import { createContext, FC, ReactNode, useContext } from 'react';
import { FeatureFlags } from '../types';

export interface IFeatureFlagsContext extends FeatureFlags {
  /** Transitional context value computed from firm/client access. This must never be sourced from AppConfig. */
  allowEstateStatus: boolean;
  allowBAA?: boolean;
  allowMessaging?: boolean;
  disableConsolidatedAccounting?: boolean;
  removeScorecard?: boolean;
}

type IFeatureFlagsContextProviderProps = Omit<IFeatureFlagsContext, 'allowEstateStatus'> & {
  computedEstateStatusAccess?: boolean;
  children?: ReactNode;
};
const FeatureFlagsContext = createContext<IFeatureFlagsContext>({
  clientGroups: false,
  allowClientProjection: false,
  allowHouseholdElementVisibility: false,
  allowEstateStatus: false,
  allowTargetScoreRanges: false,
  showElementDetailViewVideoThumbnails: true,
  showFutureIncome: true,
  showClientPersonalFinancialStatement: true,
  prospectDiscoveryAllDoneGoToDashboard: false,
  showTaskManagementSection: true,
  showClientSettings: false,
  showClientEditAccountButton: true,
  allowDocuments: true,
});

export const useFeatureFlagsContext = () => useContext(FeatureFlagsContext);

export const FeatureFlagsContextProvider: FC<IFeatureFlagsContextProviderProps> = ({
  computedEstateStatusAccess = false,
  children,
  ...props
}) => {
  return (
    <FeatureFlagsContext.Provider value={{ ...props, allowEstateStatus: computedEstateStatusAccess }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
